import { Injectable, EventEmitter } from '@angular/core';
import { finalize, takeUntil, debounceTime } from 'rxjs/operators';
import { ApiService } from '../shared/api.service';
import { SImage } from '../shared/image.model';
import { ImagesService } from '../shared/images.service';
    
@Injectable()
export class GettyService {
    images = [];
    searchFilters = {
        sort_order: {
            label: 'Sort',
            value: 'sort_order',
            search: false,
            more: true,
            multiple: false,
            options: [
                {
                    label: 'Best Match',
                    value: 'best_match',
                    checked: true,
                    secondary: false
                },
                {
                    label: 'Newest',
                    value: 'newest',
                    checked: false,
                    secondary: false
                },
                {
                    label: 'Oldest',
                    value: 'oldest',
                    checked: false,
                    secondary: false
                },
                {
                    label: 'Most Popular',
                    value: 'most_popular',
                    checked: false,
                    secondary: false
                },
                {
                    label: 'Random',
                    value: 'random',
                    checked: false,
                    secondary: false
                }
            ]
        },
        age_of_people: {
            label: 'Age',
            value: 'age_of_people',
            open: false,
            search: false,
            more: true,
            multiple: true,
            options: [
                {
                    label: 'Newborn',
                    value: 'newborn',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Baby',
                    value: 'baby',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Child',
                    value: 'child',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Teenager',
                    value: 'teenager',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Young Adult',
                    value: 'young_adult',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Adult',
                    value: 'adult',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Adults Only',
                    value: 'adults_only',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Mature Adult',
                    value: 'mature_adult',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Senior',
                    value: 'senior_adult',
                    secondary: false,
                    checked: false
                },
                {
                    label: '0-1 Month',
                    value: '0-1_months',
                    secondary: true,
                    checked: false
                },
                {
                    label: '2-5 Months',
                    value: '2-5_months',
                    secondary: true,
                    checked: false
                },
                {
                    label: '6-11 Months',
                    value: '6-11_months',
                    secondary: true,
                    checked: false
                },
                {
                    label: '12-17 Months',
                    value: '12-17_months',
                    secondary: true,
                    checked: false
                },
                {
                    label: '18-23 Months',
                    value: '18-23_months',
                    secondary: true,
                    checked: false
                },
                {
                    label: '2-3 Years',
                    value: '2-3_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '4-5 Years',
                    value: '4-5_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '6-7 Years',
                    value: '6-7_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '8-9 Years',
                    value: '8-9_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '10-11 Years',
                    value: '10-11_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '12-13 Years',
                    value: '12-13_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '14-15 Years',
                    value: '14-15_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '16-17 Years',
                    value: '16-17_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '18-19 Years',
                    value: '18-19_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '20-24 Years',
                    value: '20-24_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '20-29 Years',
                    value: '20-29_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '25-29 Years',
                    value: '25-29_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '30-34 Years',
                    value: '30-34_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '30-39 Years',
                    value: '30-39_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '35-39 Years',
                    value: '35-39_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '40-44 Years',
                    value: '40-44_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '40-49 Years',
                    value: '40-49_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '45-49 Years',
                    value: '45-49_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '50-54 Years',
                    value: '50-54_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '55-59 Years',
                    value: '55-59_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '60-64 Years',
                    value: '60-64_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '60-69 Years',
                    value: '60-69_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '65-69 Years',
                    value: '65-69_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '70-74 Years',
                    value: '70-74_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '70-79 Years',
                    value: '70-79_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '75-79 Years',
                    value: '75-79_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '80-84 Years',
                    value: '80-84_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '80-89 Years',
                    value: '80-89_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '85-89 Years',
                    value: '85-89_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '90+ Years',
                    value: '90_plus_years',
                    secondary: true,
                    checked: false
                },
                {
                    label: '100+ Years',
                    value: '100_over',
                    secondary: true,
                    checked: false
                }
            ]
        },
        compositions: {
            label: 'Composition',
            value: 'compositions',
            open: false,
            search: false,
            more: true,
            multiple: true,
            options: [
                {
                    label: 'Abstract',
                    value: 'abstract',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Candid',
                    value: 'candid',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Close Up',
                    value: 'close_up',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Copy Space',
                    value: 'copy_space',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Cut Out',
                    value: 'cut_out',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Full Frame',
                    value: 'full_frame',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Full Length',
                    value: 'full_length',
                    secondary: false,
                    checked: false
                },
                {
                    label: '3/4 Length',
                    value: 'three_quarter_length',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Headshot',
                    value: 'headshot',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Looking at Camera',
                    value: 'looking_at_camera',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Macro',
                    value: 'macro',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Portrait',
                    value: 'portrait',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Sparse',
                    value: 'sparse',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Still Life',
                    value: 'still_life',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Waist Up',
                    value: 'waist_up',
                    secondary: true,
                    checked: false
                }
            ]
        },
        ethnicity: {
            label: 'Ethnicity',
            value: 'ethnicity',
            open: false,
            search: false,
            more: true,
            multiple: true,
            options: [
                {
                    label: 'Asian',
                    value: 'east_asian,south_asian,southeast_asian',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Black',
                    value: 'black',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Caucasion',
                    value: 'caucasian',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Hispanic Latino',
                    value: 'hispanic_latino',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Japanese',
                    value: 'japanese',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Middle Eastern',
                    value: 'middle_eastern',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Mixed Race',
                    value: 'mixed_race_person',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Multi-Ethnic',
                    value: 'multiethnic_group',
                    secondary: true,
                    checked: false
                },
                {
                    label: 'Native American',
                    value: 'native_american_first_nations',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Pacific Islander',
                    value: 'pacific_islander',
                    secondary: true,
                    checked: false
                }
            ]
        },
        number_of_people: {
            label: 'Number of People',
            value: 'number_of_people',
            open: false,
            search: false,
            more: true,
            multiple: true,
            options: [
                {
                    label: 'No People',
                    value: 'none',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'One Person',
                    value: 'one',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Two People',
                    value: 'two',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Group of People',
                    value: 'group',
                    secondary: false,
                    checked: false
                }
            ]
        },
        specific_people: {
            label: 'Specific People',
            value: 'specific_people',
            open: false,
            search: '',
            more: false,
            multiple: true,
            options: []
        },
        date_from: {
            label: 'Date',
            value: 'date_from',
            open: false,
            search: '',
            more: false,
            multiple: false,
            options: [
                {
                    label: 'Last 24 Hours',
                    value: this.getDate(-1),
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Last 48 Hours',
                    value: this.getDate(-2),
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Last 72 Hours',
                    value: this.getDate(-3),
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Last 7 Days',
                    value: this.getDate(-7),
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Last 30 days',
                    value: this.getDate(-30),
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Last 12 months',
                    value: this.getDate(-365),
                    secondary: false,
                    checked: false
                }
            ]
        },
        date_to: {
            label: 'Date',
            value: 'date_to',
            open: false,
            search: '',
            more: false,
            multiple: false,
            options: []
        },
        editorial_segments: {
            label: 'Category',
            value: 'editorial_segments',
            open: false,
            search: false,
            more: false,
            multiple: false,
            options: [
                {
                    label: 'Sports',
                    value: 'sport',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Entertainment',
                    value: 'entertainment',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'News',
                    value: 'news',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Archival',
                    value: 'archival',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Royalty',
                    value: 'royalty',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Publicity',
                    value: 'publicity',
                    secondary: false,
                    checked: false
                }
            ]
        },
        orientations: {
            label: 'Orientation',
            value: 'orientations',
            open: false,
            search: false,
            more: false,
            multiple: true,
            options: [
                {
                    label: 'Horizontal',
                    value: 'horizontal',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Vertical',
                    value: 'vertical',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Square',
                    value: 'square',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Panoramic Horizontal',
                    value: 'panoramic_horizontal',
                    secondary: false,
                    checked: false
                },
                {
                    label: 'Panoramic Vertical',
                    value: 'panoramic_vertical',
                    secondary: false,
                    checked: false
                }
            ]
        },
        event_ids: {
            label: 'Event',
            value: 'event_ids',
            open: false,
            search: false,
            more: true,
            multiple: true,
            options: []
        }, 
        keyword_ids: {
            label: 'Location',
            value: 'keyword_ids',
            open: false,
            search: false,
            more: true,
            multiple: true,
            options: []
        }, 
        artists: {
            label: 'Photographer',
            value: 'artists',
            open: false,
            search: false,
            more: true,
            multiple: true,
            options: []
        } 
    }
    facets = {
        specific_people: {
            list: [],
            letters: [],
            options: {}
        },
        artists: {
            list: [],
            letters: [],
            options: {}
        },
        event_ids: {
            list: [],
            letters: [],
            options: {}
        },
        keyword_ids: {
            list: [],
            letters: [],
            options: {}
        }
    };
    working = false;
    cancel = new EventEmitter();
    downloadComplete = new EventEmitter();
    imagesUpdated = new EventEmitter();
    totalPages = 0;
    error = '';
    downloadError = '';
    searchText = '';
    firstLoad = false;
    popoutName = 'swarm_getty_search';
    popoutStorageKey = 'swarm_getty_search_data';
    popoutOpenKey = 'swarm_getty_search_open';
    currentAssignment = {
        id: 0,
        title: ''
    };
    subscribedEvents = [];

    private _page = 1;
    set page(page) {
        const prev = this._page;
        if( typeof page === 'string' ) {
            page = parseInt(page);
        }
        if( !page ) {
            page = prev;
        }
        if( page > this.totalPages && this.totalPages > 0 ) {
            page = this.totalPages;
        }
        if( page < 1 ) {
            page = 1;
        }
        this._page = page;
    }
    get page() {
        return this._page;
    }

    constructor(private api: ApiService, private imagesService: ImagesService){}

    getDate(days) {
        const time = Date.now();
        let multiplier = 60 * 60 * 24 * 1000; // 1 day
        const newTime = time + (multiplier * days);
        const dateFrom = new Date(newTime);
        return this.formatDate(dateFrom);
    }
    formatDate(date) {
        const mm = ('0' + (date.getMonth() + 1)).slice(-2);
        const dd = ('0' + date.getDate()).slice(-2);
        return date.getFullYear() + '-' + mm + '-' + dd;
    }
    getFilters() {
        const searchFilters = this.searchFilters;
        const keys = Object.keys(searchFilters);
        const filters = {};
        for(var i = 0; i < keys.length; i++) {
            const key = keys[i];
            const values = searchFilters[key].options.filter(item => item.checked);
            if( values.length > 0 ) {
                filters[key] = values.map(item => item.value).join(',');
            } else if( searchFilters[key].search ) {
                filters[key] = searchFilters[key].search;
            }
        }
        return filters;
    }
    search(paginate) {
        if( this.working ) {
            this.cancel.emit(false);
        }
        const filters = this.getFilters();
        this.resetErrors();
        this.working = true;
        if( !paginate ) {
            this.page = 1;
        }
        this.api.doAction('post', 'getty', {
            action: 'search',
            page: this.page,
            phrase: this.searchText,
            filters: filters
        }).pipe(
            debounceTime(1000),
            takeUntil(this.cancel),
            finalize(() => {
                this.working = false;
            })
        ).subscribe(
            data => {
                this.firstLoad = true;
                this.images = data.images.map(item => new SImage(item));
                this.imagesUpdated.emit();
                this.totalPages = Math.ceil(data.result_count / 50);
                localStorage.setItem(this.popoutStorageKey, JSON.stringify({
                    action: 'FILTERSCHANGED',
                    filters: filters,
                    images: this.images,
                    searchText: this.searchText,
                    totalPages: this.totalPages
                }));
                this.setAdditionalOptions(data.images);
            },
            err => {
                if( err.error && err.error.code == 'getty_error' ) {
                    this.error = this.getErrorMessage(err.error.data.response);
                } else {
                    this.error = 'An internal server error occured. Please try again and contact your administrator if the error persists';
                    throw err;
                }                
            }
        );
        this.getFacets();
    }
    setAdditionalOptions(images) {
        const people = {};
        const events = {};
        const locations = {};
        const artists = {};
        for(var i = 0; i < images.length; i++) {
            const image = images[i];
            const peopleArr = image.people;
            for(var j = 0; j < peopleArr.length; j++) {
                const person = peopleArr[j];
                const personKey = person.toLowerCase();
                people[personKey] = person;
            }
            const eventsArr = image.event_ids;
            for(var k = 0; k < eventsArr.length; k++) {
                const eventId = eventsArr[k];
                events[eventId] = eventId;
            }
            const keywords = image.keywords;
            for(var l = 0; l < keywords.length; l++) {
                const keyword = keywords[l];
                if( keyword.type == 'Location' ) {
                    const locationKey = keyword.text.toLowerCase();
                    locations[locationKey] = keyword;
                }
            }
            const artistKey = image.artist.toLowerCase();
            artists[artistKey] = image.artist;
        }
        this.getEvents( Object.keys(events) );
        const specific_people = this.searchFilters.specific_people;
        specific_people.options = specific_people.options.filter(item => item.checked);
        const selectedPeople = specific_people.options.map(item => item.label.toLowerCase());
        const peoples = Object.keys(people);
        peoples.sort();
        for(var m = 0; m < peoples.length; m++) {
            const person = peoples[m];
            if( selectedPeople.indexOf(person) === -1 ) {
                const name = people[person];
                specific_people.options.push({
                    label: name,
                    value: name,
                    secondary: m > 3,
                    checked: false
                });
            }
        }
        const artistsFilter = this.searchFilters.artists;
        artistsFilter.options = artistsFilter.options.filter(item => item.checked);
        const selectedArtists = artistsFilter.options.map(item => item.label.toLowerCase());
        const artistsCollection = Object.keys(artists);
        artistsCollection.sort();
        for(var n = 0; n < artistsCollection.length; n++ ) {
            const artist = artistsCollection[n];
            if( selectedArtists.indexOf(artist) === -1 ) {
                const name = artists[artist];
                artistsFilter.options.push({
                    label: name,
                    value: name,
                    secondary: n > 3,
                    checked: false
                });
            }
        }
        let locationFilter = this.searchFilters.keyword_ids;
        locationFilter.options = locationFilter.options.filter(item => item.checked);
        const selectedLocations = locationFilter.options.map(item => item.label.toLowerCase());
        const locationsCollection = Object.keys(locations);
        locationsCollection.sort();
        for(var o = 0; o < locationsCollection.length; o++) {
            const location = locationsCollection[o];
            if( selectedLocations.indexOf(location) === -1 ) {
                locationFilter.options.push({
                    label: locations[location].text,
                    value: locations[location].keyword_id,
                    secondary: o > 3,
                    checked: false
                });
            }
        }
    }
    getEvents(ids) {
        const event_ids = this.searchFilters.event_ids;
        event_ids.options = event_ids.options.filter(item => item.checked);
        if( !ids.length ) {
            return;
        }
        this.api.doAction('post', 'getty', {
            action: 'get_events',
            page: this.page,
            ids: ids
        }).pipe(
            debounceTime(1000),
            takeUntil(this.cancel)
        ).subscribe(
            data => {
                const events = data.events;
                const selected = event_ids.options.map(item => item.value);
                for(var i = 0; i < events.length; i++) {
                    const event = events[i];
                    if( selected.indexOf(event.id) === -1 ) {
                        event_ids.options.push({
                            label: event.name,
                            value: event.id,
                            date: event.start_date,
                            secondary: i > 3,
                            checked: false
                        });
                    }
                }
            }
        );
    }
    getFacets() {
        this.getFacet('artists');
        this.getFacet('events');
        this.getFacet('locations');
        this.getFacet('specific_people');
    }
    facetSetup(facet, options) {
        const letters = {};
        const isEventsFilter = facet == 'event_ids';
        for(var i = 0; i < options.length; i++) {
            const option = options[i];
            let name = option.name.toLowerCase();
            if( name == '-' ) {
                continue; // why you do dis getty?
            }
            let letter = name.charAt(0);
            if( isEventsFilter ) {
                letter = new Date(option.date).getFullYear();
            }
            if( !letters[letter] ) {
                letters[letter] = [];
            }
            letters[letter].push(option);
        }
        let letterOptions = Object.keys(letters);
        letterOptions = letterOptions.sort();
        if( isEventsFilter ) {
            letterOptions.reverse();
        }
        this.facets[facet].letters = letterOptions;
        for(var j = 0; j < letterOptions.length; j++) {
            const letter = letterOptions[j];
            letters[letter] = letters[letter].sort(function(a, b) {
                if( isEventsFilter ) {
                    const adate = new Date(a.date).getTime();
                    const bdate = new Date(b.date).getTime();
                    return adate <= bdate ? 1 : -1;
                }
                return a.name <= b.name ? -1 : 1;
            });
        }
        this.facets[facet].options = letters;
    }
    getFacet(facet) {
        let alias = facet;
        switch(facet) {
            case 'events':
                alias = 'event_ids';
                break;
            case 'locations':
                alias = 'keyword_ids';
                break;
            default:
                break;
        }
        this.facets[alias] = {
            list: [],
            letters: [],
            options: {}
        };
        this.api.doAction('post', 'getty', {
            action: 'facet_search',
            page: this.page,
            phrase: this.searchText,
            filters: this.getFilters(),
            facet: facet
        }).pipe(
            debounceTime(1000),
            takeUntil(this.cancel)
        ).subscribe(
            data => {
                this.facets[alias].list = data.facets[facet];
                this.facetSetup(alias, this.facets[alias].list);
            }
        );
    }
    getErrorMessage(res) {
        let error = res.ErrorMessage;
        switch(res.ErrorCode) {
            case 'DateEndBeforeDateStart':
                error = '<i>From</i> date should be earlier than <i>To</i> date';
                break;
            case 'SearchPhraseOrEditorialSegmentRequired':
                error = 'Search phrase cannot be empty or category must be selected';
                break;
            default:
                break;
        }
        return error;
    }
    setImageDownload(isDownloading:boolean, img:SImage): void {
        const images = this.images;
        for(var i = 0; i < images.length; i++) {
            if( img.id == images[i].id ) {
                images[i].downloading = isDownloading;
            }
        }
    }
    download(img:SImage, id:number, callback:(oldImage:SImage, newImage:SImage) => void|null = null): void {
        this.downloadError = '';
        this.setImageDownload(true, img);
        localStorage.setItem(this.popoutStorageKey, JSON.stringify({
            action: 'DOWNLOADING',
            image: img,
            id: id
        }));
        this.api.doAction('post', 'getty', {
            action: 'download',
            image: img,
            id: id
        }).subscribe(
            data => {
                const image = new SImage(data);
                // handle gett reupload - don't add to images array if already exists
                if ( !this.imagesService.images.some(img => img.id == image.id) ) {
                    this.imagesService.images.unshift(image);
                }

                // #184229181 don't hide downloaded images from getty results
                // const gettyImages = this.images;
                // let i = gettyImages.length;
                // while(i--) {
                //     if( gettyImages[i].id == image.gettyId ) {
                //         gettyImages.splice(i, 1);
                //         break;
                //     }
                // }
                this.setImageDownload(false, img);
                this.downloadComplete.emit(image);
                if( callback !== null ) {
                    callback(img, image);
                }
                localStorage.setItem(this.popoutStorageKey, JSON.stringify({
                    action: 'DOWNLOADCOMPLETE',
                    image: image
                }));
            },
            err => {
                this.downloadError = this.getDownloadError(err.error);
                this.setImageDownload(false, img);
                localStorage.setItem(this.popoutStorageKey, JSON.stringify({
                    action: 'DOWNLOADERROR',
                    image: img,
                    error: err
                }));
                throw err;
            }
        );
    }
    getDownloadError(error) {
        if( error && error.code == 'rest_upload_sideload_error' ) {
            return 'There was an error downloading the image. Please try again.';
        }
        return 'We are having trouble connecting to Getty Images.';
    }
    openPopout() {
        const url = this.api.getProp('url') + '/getty';
        window.open(url, this.popoutName, 'width=1200&height=1000&left=0&top=0');
    }
    setFiltersFromStorage(storeFilters) {
        const searchFilters = this.searchFilters;
        const searchKeys = Object.keys(searchFilters);
        for(var i = 0; i < searchKeys.length; i++) {
            const key = searchKeys[i];
            const value = storeFilters[key];
            const filter = searchFilters[key];
            const options = filter.options;
            if( !value ) {
                if( filter.search !== false ) {
                    filter.search = '';
                }
                for(var j = 0; j < options.length; j++) {
                    const option = options[j];
                    option.checked = false;
                }
            } else {
                if( filter.search !== false ) {
                    filter.search = value;
                }
                const values = value.split(',');
                for(var k = 0; k < options.length; k++) {
                    const option = options[k];
                    if( values.indexOf(option.value) !== -1 ) {
                        option.checked = true;
                    } else {
                        option.checked = false;
                    }
                }
            }
        }
    }
    handleStorageEvents(e) {
        try {
            const key = this.popoutStorageKey;
            if( e.key !== key || e.newValue === null ) {
                return;
            }
            const store = JSON.parse(e.newValue);
            if( this.subscribedEvents.indexOf(store.action) === -1 ) {
                return;
            }
            console.log(store.action, store);
            switch(store.action) {
                case 'REQUESTFIRSTLOAD':
                    localStorage.setItem(key, JSON.stringify({
                        action: 'FULLFILLFIRSTLOAD',
                        images: this.images,
                        filters: this.getFilters(),
                        totalPages: this.totalPages,
                        searchText: this.searchText,
                        loaded: this.firstLoad
                    }));
                    break;
                case 'FULLFILLFIRSTLOAD':
                    if( this.working || this.firstLoad ) {
                        break;
                    }
                    if( !store.firstLoad ) {
                        this.search(false);
                        break;
                    }
                    this.images = store.images;
                    this.imagesUpdated.emit();
                    this.setFiltersFromStorage(store.filters);
                    this.totalPages = store.totalPages;
                    this.searchText = store.searchText;
                    this.setAdditionalOptions(store.images);
                    this.firstLoad = true;
                    this.getFacets();
                    break;
                case 'FILTERSCHANGED':
                    if( this.working ) {
                        break;
                    }
                    this.images = store.images;
                    this.imagesUpdated.emit();
                    this.setFiltersFromStorage(store.filters);
                    this.totalPages = store.totalPages;
                    this.searchText = store.searchText;
                    this.setAdditionalOptions(store.images);
                    this.getFacets();
                    break;
                case 'ASSIGNMENTLOADED':
                case 'WINDOWFOCUSED':
                    this.currentAssignment = store.currentAssignment;
                    break;
                case 'INSERTINTOASSIGNMENTVOID':
                    // maybe check id against request id
                    this.error = 'Error connecting to assignment. Please drag image into assignment instead.';
                    break;
                case 'DOWNLOADING':
                    this.setImageDownload(true, store.image);
                    break;
                case 'DOWNLOADERROR': 
                    this.downloadError = this.getDownloadError(store.error.error);
                    this.setImageDownload(false, store.image);
                    break;
                case 'RESETERRORS': 
                    this.downloadError = '';
                    this.error = '';
                    break;
                case 'DOWNLOADCOMPLETE':
                    // check against assignment id
                        const gettyImages = this.images;
                        let i = gettyImages.length;
                        while(i--) {
                            if( gettyImages[i].id == store.image.gettyId ) {
                                gettyImages.splice(i, 1);
                                break;
                            }
                        }
                        this.downloadComplete.emit(store.image);
                    break;
                default:
                    break;
            }
        } catch(e) {
            console.log('Getty Search storage error', e);
            throw e;
        }
    }
    requestFirstLoad(id) {
        localStorage.setItem(this.popoutStorageKey, JSON.stringify({
            action: 'REQUESTFIRSTLOAD',
            id: id
        }));
    }
    resetErrors() {
        this.error = '';
        this.downloadError = '';
        localStorage.setItem(this.popoutStorageKey, JSON.stringify({
            action: 'RESETERRORS'
        }));
    }
}